import PartnersListWithPartnerGroup from './PartnersListWithPartnerGroup';
export default PartnersListWithPartnerGroup;
